import baseRoute from '../baseRoute';

type RouteDefinition = `${typeof baseRoute}/${number | ':id'}`;

export const ROUTE: RouteDefinition = `${baseRoute}/:id`;

export const URL = (id: number): RouteDefinition => `${baseRoute}/${id}`;
